import * as React from 'react';
import ContentLoadingProps from './ContentLoadingProps.interface';
import './content-loading.scss';

const ContentLoading = ({
  loadingMessage = 'Loading...',
}: ContentLoadingProps): JSX.Element => { // eslint-disable-line arrow-body-style
  return (
    <div className="contentLoading">
      <img src="/images/loading-animation.svg" alt="loading" className="contentLoadingImage" />
      <span>{loadingMessage}</span>
    </div>
  );
};

export default ContentLoading;
